import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../Component/Button/Button';
import Input from '../../Component/Input/Input';
import { Logo } from '../../constant/imagePath';
import { saveLoginUserData } from '../../store/auth/authSlice';

import classes from './AgentCompanyLogin.module.css';
// import Checkbox from '../../Component/Checkbox/Checkbox';
import { useTranslation } from 'react-i18next';
import { HiOutlineChevronDown } from 'react-icons/hi';
import { IoChevronBackOutline } from 'react-icons/io5';
import { RiAccountCircleLine } from 'react-icons/ri';
import CustomPopover from '../../Component/CustomPopover';
import { useLoginAgentCompanyMutation } from '../../store/apiSlice/apiSlice';
import { setDirection, setSelectLanguage } from '../../store/language/languageSlice';
import {
  setAllCompareList,
  setAllFavorite,
  setAllInquiryMessageAndRequest,
  setAllPropertyProjectsAndEvents,
  setAllSavedSearch
} from '../../store/notification/notificationSlice';

function Login() {
  const [openLanguages, setOpenLanguages] = useState(null);
  const { selectedLanguage, direction } = useSelector((state) => state?.languageReducer);
  const { i18n } = useTranslation('webCommon');
  const { t } = useTranslation('loginAndSignup');
  const d = (e) => t(`login.${e}`);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [signinFn, { isLoading: signinLoading }] = useLoginAgentCompanyMutation();
  const [formStates, setFormStates] = useState({
    email: '',
    password: ''
  });
  const { languages } = useSelector((state) => state.commonReducer);
  const mapLang = languages && languages;

  function handleFormStateUpdate(key, value) {
    setFormStates({ ...formStates, [key]: value });
  }
  async function onLogin() {
    const response = await signinFn(formStates);
    if (response?.data) {
      if(response?.data?.requiresOtp){
        return navigate(`/verify-otp?email=${formStates?.email}&requiresOtp=x`);
      }
      dispatch(saveLoginUserData(response?.data));
      if (response?.data?.data?.propertyProjectsAndEvents) {
        dispatch(setAllPropertyProjectsAndEvents(response?.data?.data?.propertyProjectsAndEvents));
      }
      if (response?.data?.data?.favorite) {
        dispatch(setAllFavorite(response?.data?.data?.favorite));
      }
      if (response?.data?.data?.savedSearches) {
        dispatch(setAllSavedSearch(response?.data?.data?.savedSearches));
      }
      if (response?.data?.data?.compareList) {
        dispatch(setAllCompareList(response?.data?.data?.compareList));
      }
      if (response?.data?.data?.inquiryMessageAndRequest) {
        dispatch(setAllInquiryMessageAndRequest(response?.data?.data?.inquiryMessageAndRequest));
      }
      if (response?.data?.data?.user?.role == 'company') {
        navigate('/company/dashboard');
      } else if (response?.data?.data?.user?.role == 'agent') {
        navigate('/agent/dashboard');
      } else {
        // return navigate('/');
        navigate('/account-settings');
      }
    }
  }

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    dispatch(setSelectLanguage(lng));
    if (['ar', 'fa'].includes(lng)) {
      dispatch(setDirection('rtl'));

      // document.body.dir = i18n.dir();
    } else {
      dispatch(setDirection('ltr'));

      // document.body.dir = i18n.dir("ltr");
    }
  };


  return (
    <div>
      {/* <Header /> */}
      {/* <div className={classes.bg}>
        <div className={classes.content}>
          <div className={classes.logoDiv}>
            <img src={WhiteLogo} />
            <h5>{d('role')}</h5>
          </div>
          <form
            className={classes.form}
            onSubmit={(e) => {
              e?.preventDefault();
              onLogin();
            }}>
            <Row className={classes.formRow}>
              <Col md={12}>
                <h4>{d('title')}</h4>
              </Col>

              <Col md={12}>
                <Input
                  value={formStates?.email}
                  setValue={(e) => handleFormStateUpdate('email', e)}
                  type={'email'}
                  placeholder={d('email')}
                />
              </Col>
              <Col md={12}>
                <Input
                  value={formStates?.password}
                  setValue={(e) => handleFormStateUpdate('password', e)}
                  type={'password'}
                  placeholder={d('password')}
                />
              </Col>
              <Col md={12} className="text-end">
                <Link to={'/forgot-password'} className={`link ${classes.link}`}>
                  {d('forgotPassword')}
                </Link>
              </Col>

              <Col md={12} className={classes.btns}>
                <Button type={'submit'} variant="secondary">
                  {signinLoading ? d('loading') : d('login')}
                </Button>
              </Col>
            </Row>
          </form>
          <div className={classes.createAccountText}>
            <p>{d('notAMemberYet')}</p>
            <p>
              {d('createP') + ' '}
              <Link to={'/advertise-with-us'} className={`link ${classes.link}`}>
                {d('here')}
              </Link>{' '}
            </p>
          </div>
        </div>
      </div> */}
      <div className={classes.bg}>
        <div className={classes.content}>
          <form
            className={classes.form}
            onSubmit={(e) => {
              e?.preventDefault();
              onLogin();
            }}>
            <div className={classes.backBtn} onClick={() => navigate(-1)}>
              <IoChevronBackOutline size={24} />
            </div>
            <Row className={classes.formRow}>
              <div className={classes.Header}>
                <Col md={9} dir={direction}>
                  <div className={classes.logoDiv}>
                    <img src={Logo} />
                  </div>
                  <h4>
                    {/* {d('login')} */}
                    {d('role')}
                  </h4>
                </Col>

                <Col md={3}>
                  <CustomPopover
                    anchorEl={openLanguages}
                    setAnchorEl={setOpenLanguages}
                    Component={
                      <ul className={[classes?.languagesOptions, 'ltr'].join(' ')}>
                        {mapLang?.map((item, index) => {
                          return (
                            <button 
                            key={`${item?._id}-${index}`}
                            className='btnWrapper'
                            onClick={() => {
                              changeLanguage(item?.value);
                              setOpenLanguages(null);
                            }}
                            >

                           
                            <li
                              key={`${item?._id}-${index}`}
                              data-selected={selectedLanguage == item?.value}
                            >
                              <img
                              alt={item?.label}
                               src={item?.flag} /> {item?.label}
                            </li>
                            </button>
                          );
                        })}
                      </ul>
                    }
                    className={classes.overlay}
                    TriggerComp={() => (
                      <li>
                        <Button
                          variant="transparent"
                          rightIcon={<HiOutlineChevronDown size={20} color="#000" />}
                          className={('t-t-c', classes.languageBtn)}>
                         
                          <img
                            alt={mapLang?.find((item) => item?.value === selectedLanguage)?.label}
                            className={classes.flag}
                            src={mapLang?.find((item) => item?.value === selectedLanguage)?.flag}
                          />
                        </Button>
                      </li>
                    )}
                  />
                </Col>
              </div>

              <Col md={12}>
                <Input
                  label={d('email')}
                  value={formStates?.email}
                  setValue={(e) => handleFormStateUpdate('email', e)}
                  type={'email'}
                  placeholder={d('email')}
                  className={classes.input}
                />
              </Col>
              <Col md={12}>
                <Input
                  label={
                    <Col md={12} className={classes.forgotPassword}>
                      {d('password')}
                      <Link to={'/forgot-password'} className={`link ${classes.link}`}>
                        {d('forgotPassword')}
                      </Link>
                    </Col>
                  }
                  value={formStates?.password}
                  setValue={(e) => handleFormStateUpdate('password', e)}
                  type={'password'}
                  placeholder={d('password')}
                  className={classes.input}
                />
              </Col>

              <Col md={12} className={classes.btns}>
                <Button type={'submit'} variant="primary">
                  {signinLoading ? d('loading') : d('title')}
                </Button>
              </Col>
              <Col md={12} className={classes.textCenter}>
                <p className={classes.text}>
                  {d('dontHaveAnAccount')}{' '}
                  <Link to={'/advertise-with-us'} className={`link ${classes.link}`}>
                    {d('signup')}
                  </Link>
                </p>
              </Col>
            </Row>
          </form>
          <Col md={12} className={classes.AgentLogin}>
            <RiAccountCircleLine color="#F28E1D" size={30} />
            <Link to={'/login'} className={`link ${classes.link}`}>
              <p> {d('AgentLogin')}</p>
            </Link>
          </Col>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
}

export default Login;
